export const SET_USER = 'SET_USER';

export const SET_MODULES = 'SET_MODULES';
export const SET_MODULE_STATUS = 'SET_MODULE_STATUS';
